import axios from "axios";
import { DataGrid } from "devextreme-react";
import {
  Column,
  Editing,
  FilterRow,
  HeaderFilter,
  LoadPanel,
  Paging,
  Scrolling,
  SearchPanel,
  Selection,
  Sorting,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getDateString } from "../../../../common/date";

export default function CommentGrid(props) {
  const { contrNo } = props;

  const userInfo = useSelector((state) => state.userInfo);

  const [dataSource, setDataSource] = useState(null);
  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: "SEQ",
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/paytStatus/billingTiming/comment/${contrNo}`
          );

          return result.data;
        },
        insert: async (values) => {
          await axios.post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/paytStatus/billingTiming/comment/${contrNo}`,
            {
              employeeNo: userInfo.employeeNo,
              comment: values.comment,
            }
          );
        },
        update: async (key, values) => {
          await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/payt/paytStatus/billingTiming/comment/${contrNo}/${key}`,
            values
          );
        },
        remove: async (key) => {},
      })
    );
  }, [contrNo]);

  const calculateDisplayValue = (data) => {
    if (data.employeeNo) {
      return `${data.name} (${data.employeeNo}) ${data.date} <br /><br /> ${data.comment}`;
    } else {
      return `${userInfo.name} (${userInfo.employeeNo}) ${getDateString(
        new Date()
      )} <br /> <br/>${data.comment}`;
    }
  };

  const onCellPrepared = (e) => {
    if (e.rowType == "header") {
      e.cellElement.style.fontWeight = "bold";
      e.cellElement.style.textAlign = "center";
      e.cellElement.style.backgroundColor = "#FFE699";
    }
  };

  const onEditingStart = (e) => {
    if (e.data.employeeNo && e.data.employeeNo != userInfo.employeeNo) {
      e.cancel = true;
    }
  };

  return (
    <DataGrid
      dataSource={dataSource}
      keyExpr={"SEQ"}
      showBorders={true}
      allowColumnReordering={true}
      allowColumnResizing={true}
      rowAlternationEnabled={true}
      showRowLines={true}
      width={"100%"}
      height={"100%"}
      style={{
        maxHeight: "calc(100vh - 145px)",
      }}
      repaintChangesOnly={true}
      highlightChanges={true}
      columnAutoWidth={true}
      wordWrapEnabled={true}
      onCellPrepared={onCellPrepared}
      onEditingStart={onEditingStart}
    >
      {/* <SearchPanel visible={true} highlightCaseSensitive={true} width={200} /> */}
      <Scrolling
        mode={"virtual"}
        rowRenderingMode={"virtual"}
        columnRenderingMode={"virtual"}
        showScrollbar={"always"}
      />
      <LoadPanel enabled={true} />
      <HeaderFilter visible={true} />
      {/* <FilterRow visible={true} applyFilter={"auto"} /> */}
      <Paging enabled={false} />
      <Selection mode="single" />

      <Editing
        mode={"batch"}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
        selectTextOnEditStart={true}
        startEditAction={"dblClick"}
      />

      <Column
        dataField={"comment"}
        caption={"Comment"}
        calculateDisplayValue={calculateDisplayValue}
        encodeHtml={false}
        // showEditorAlways={true}
        // customizeText={customizeText}
      />
    </DataGrid>
  );
}
